import { Air as AirIcon, Group as GroupIcon } from '@mui/icons-material';

import {
  HubIcon,
  MainMapIcon,
  MonitorMenuIcon,
  PlaneMenuIcon,
  PlannerMenuIcon,
  routes,
  StatisticsIcon,
  StatsLogoIcon,
} from '#shared';

import type { MenuItem } from '../model';

export const commandCenterMenuItems: MenuItem[] = [
  {
    id: routes.MAIN_MAP,
    icon: <MainMapIcon />,
    title: 'Active Cases Map',
    type: 'route',
    showOnSmall: 'cc',
  },
  {
    id: routes.AIRCRAFTS_MAP,
    icon: <PlaneMenuIcon />,
    type: 'route',
    title: 'Air Fleet Tracker',
  },
  {
    id: routes.CREW_AVAILABILITY,
    icon: <GroupIcon />,
    type: 'route',
    title: 'Crew Availability',
    showOnSmall: 'cc',
  },
  {
    id: routes.AIRCRAFTS_CARDS,
    icon: <PlannerMenuIcon />,
    type: 'route',
    title: 'Air Fleet Planner',
    showOnSmall: 'cc',
  },
  {
    id: routes.ERRORS,
    icon: <MonitorMenuIcon />,
    type: 'route',
    title: 'System Monitor',
    showOnSmall: 'cc',
  },
  {
    id: routes.STATISTICS,
    icon: <StatisticsIcon />,
    type: 'route',
    title: 'Statistics',
    showOnSmall: 'cc',
  },
  {
    id: routes.HUBS_REPORT,
    icon: <HubIcon />,
    type: 'route',
    title: 'Hubs Report',
  },
  // {
  //   id: routes.WEATHER,
  //   icon: <WeatherIcon />,
  //   type: 'route',
  //   title: 'Aviation Weather',
  // },
  {
    id: routes.WEATHER_WINDS,
    icon: <AirIcon />,
    type: 'route',
    title: 'Aviation Winds',
  },
];

export const statsMenuItems: MenuItem[] = [
  {
    id: routes.STATS,
    icon: <StatsLogoIcon />,
    type: 'route',
    title: 'TMDX Statistics',
    showOnSmall: 'stats',
  },
];
